import { render, staticRenderFns } from "./classJournal.vue?vue&type=template&id=5b0379d5"
import script from "./classJournal.vue?vue&type=script&lang=js"
export * from "./classJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports